<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24" v-if="JSON.stringify(meterRepair)!='{}'">
              <a-divider orientation="left">{{ $t('报修信息') }}</a-divider>
              <detail-list>
                <detail-list-item :term="$t('报修人名称')">{{meterRepair.repairName}}</detail-list-item>
                <detail-list-item :term="$t('报修人电话')">{{meterRepair.repairPhone}}</detail-list-item>
                <detail-list-item :term="$t('报修地址')">{{meterRepair.repairAddress}}</detail-list-item>
                <detail-list-item :term="$t('报修时间')">{{meterRepair.repairTime}}</detail-list-item>
                <detail-list-item :term="$t('报修描述')">{{meterRepair.repairDescription}}</detail-list-item>
                <detail-list-item :term="$t('是否解决')">{{meterRepair.isSolve==0?$t('已解决'):$t('未解决')}}</detail-list-item>
              </detail-list>
              <div style="color: #999;">
                {{ $t('报修图片:') }}
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="fileList" :disabled="true"></j-image-upload>
              </div>
              <template v-if="meterRepair.isSolve==0">
                <a-divider orientation="left">{{ $t('修理信息') }}</a-divider>
                <detail-list :col="2">
                  <detail-list-item :term="$t('修理人员电话')">{{meterRepair.fixPhone}}</detail-list-item>
                  <detail-list-item :term="$t('是否解决')" v-if="meterRepair.fixSolve!=null">{{meterRepair.fixSolve==0?$t('已解决'):$t('未解决')}}</detail-list-item>
                  <detail-list-item :term="$t('修理人员描述')">{{meterRepair.fixDescription}}</detail-list-item>
                </detail-list>
                <div style="color: #999;">
                  {{ $t('修理图片:') }}
                  <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="fileList1" :disabled="true"></j-image-upload>
                </div>
              </template>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('审核意见')" prop="audit">
                <a-radio-group v-model="model.audit">
                  <a-radio :value="1">{{ $t('通过') }}</a-radio>
                  <a-radio :value="0">{{ $t('驳回') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import {PhoneNumberPattern} from '@/utils/regPattern'
  export default {
    // mixins: [JeecgListMixin],
    name: 'auditModal',
    components: {
      DetailList,
      DetailListItem,
      JImageUpload
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          queryById: "/jeecg-engineering/ticket/tickets/queryById",
          edit: "/jeecg-engineering/engineering/meterRepair/edit"
        },
        candidateUsersList: [],
        meterRepair:{},
        fileList:'',
        fileList1:''
      }
    },
    computed: {
      validatorRules() {
        return {
          audit:{ required: true,message: this.$t('请选择审批意见'), trigger: 'change' },
          remark:{ required: !(this.model.audit == 1),message: this.$t('请输入备注'), trigger: 'input' },
        }
      },
    },
    methods: {
      getUserList(){
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      init(row){
        this.title = this.$t('接单');
        this.visible = true;
        this.model = {};
        this.model.id = row.id;
        this.model.ticketsType = row.ticketsType;
        this.model.ticketsId = row.id;
        this.getUserList();
        getAction(this.url.queryById,{id:row.id}).then(res=>{
          if(res.success){
            this.model.ticketsState = res.result.ticketsState;
            this.meterRepair = res.result.meterRepair;
            this.$nextTick(()=>{
              this.$set(this,'fileList',res.result.meterRepair.repairPicture);
              this.$set(this,'fileList1',res.result.meterRepair.fixPicture);
            })
          }
        })
        
      },
      handleCancel() {
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            let httpurl = '';
            if(that.model.audit == 1){
              httpurl+=this.url.pass;
            }else{
              httpurl+=this.url.reject;
            }
            let params = {
              dataId: that.model.id,
              values: {
                dataId: that.model.id,
                isSolve: that.meterRepair.isSolve,
              },
              comment: that.model.remark
            }
            postAction(httpurl,params).then((res) => {
              if (res.success) {
                that.$message.success(this.$t('操作成功'));
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }else{
            this.$message.warning(this.$t('存在必填内容未填！'))
          }
        })
      },
    }
  }
</script>